var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24659_9366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50182 13.4751L4.61016 10.5834C4.28516 10.2584 3.76016 10.2584 3.43516 10.5834C3.11016 10.9084 3.11016 11.4334 3.43516 11.7584L6.91849 15.2418C7.24349 15.5668 7.76849 15.5668 8.09349 15.2418L16.9102 6.4251C17.2352 6.1001 17.2352 5.5751 16.9102 5.2501C16.5852 4.9251 16.0602 4.9251 15.7352 5.2501L7.50182 13.4751Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24659_9366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.934135dc.svg";
export { ForwardRef as ReactComponent };